<div class="grid-y success-page">
  <div class="cell">
    <app-top-bar></app-top-bar>
  </div>
  <div class="grid-y success-container">
    <div class="cell success-header">
      <h2>{{"data-refresh.success-page.heading" | translate}}</h2>
    </div>
    <div class="cell button-div">
      <div class="grid-x">
        <div class="cell small-12 success-button-info success-button-info-top">
          <span>{{"data-refresh.success-page.update-profile-desc" | translate}}</span>
        </div>
        <div class="cell small-12 medium-shrink success-button-cell">
          <a id="update-profile"  class="button success-button" [href]="matHost" target="_blank">{{"eeoc-form.success-update-profile" | translate}}</a>
        </div>
        <div class="cell small-12 medium-4 success-button-info success-button-info-right">
          <span>{{"data-refresh.success-page.update-profile-desc" | translate}}</span>
        </div>
      </div>
    </div>
    <div class="cell button-div">
      <div class="grid-x">
        <div class="cell small-12 success-button-info success-button-info-top">
          <span>{{"data-refresh.success-page.find-jobs-desc" | translate}}</span>
        </div>
        <div class="cell small-12 medium-shrink success-button-cell">
          <a id="find-jobs"  class="button  success-button "  [href]="aquentWebsite + '/find-work'" target="_blank">{{"eeoc-form.success-find-jobs" | translate}}</a>
        </div>
        <div class="cell small-12 medium-4 success-button-info success-button-info-right">
          <span>{{"data-refresh.success-page.find-jobs-desc" | translate}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="cell auto"></div>
  <div class="cell footer-div">
    <app-footer></app-footer>
  </div>
</div>
